import { updatePrimaryPalette, updateSurfacePalette, palette } from '@primevue/themes'
// import PrimeVuePresetThemes from '@/enums/PrimeVuePresetThemes'
// import { getCurrentUser } from 'vuefire'
// import { useTenantStore } from '~/store/tenant'
// import { getTenantThemeSettings, updatePrimaryColor, updateSurfaceColor } from '~/modules/tenant/action.js'

export const useThemeUtils = () => {
  // const tenantStore = useTenantStore()

  const { getTheme, updateTheme } = useWorkSpace()

  async function changePreset() {
    // switch (preset) {
    //   case PrimeVuePresetThemes.AURA:
    //     usePreset(Aura)
    //     break
    //   case PrimeVuePresetThemes.NORA:
    //     usePreset(Nora)
    //     break
    //   case PrimeVuePresetThemes.LARA:
    //     usePreset(Lara)
    //     break
    //   default:
    //     usePreset(Aura)
    //     break
    // }
    // if (tenantStore.themeSettings.primaryColor) changePrimaryColor(tenantStore.themeSettings.primaryColor)
    // if (tenantStore.themeSettings.surfaceColor) changeSurfaceColor(tenantStore.themeSettings.surfaceColor)
    // if (tenantStore.themeSettings.darkMode) changeDarkMode(tenantStore.themeSettings.darkMode)
    // if (preset !== userStore.currentPreset) await userStore.updatePreset(preset)
  }

  async function changePrimaryColor(color: string) {
    const isHex = color.startsWith('#')

    let colorPalette
    // if (isHex) {
    colorPalette = palette(`#${color}`)
    // }
    // else {
    //   colorPalette = palette(`{${color}}`)
    // }
    updatePrimaryPalette(colorPalette)
    // tenantStore.updatePrimaryColorState(
    //   color,
    //   isHex,
    // )

    // if (color !== tenantStore.themeSettings.primaryColor) await updatePrimaryColor(color)
  }

  async function changeSurfaceColor(color: string, isHex: boolean = false) {
    let colorPalette
    if (isHex) {
      colorPalette = palette(`#${color}`)
    }
    else {
      colorPalette = palette(`{${color}}`)
    }

    // const colorPalette = palette(`{${color}}`)
    updateSurfacePalette(colorPalette)
    // tenantStore.updateSurfaceColorState(
    //   color,
    //   isHex,
    // )
    // if (color !== tenantStore.themeSettings.surfaceColor) await updateSurfaceColor(color)
  }

  async function changeDarkMode(bool: boolean) {
    const element = document.querySelector('html')
    const darkMode = element?.classList.contains('my-app-dark') ? true : false
    if (element && bool !== darkMode) element.classList.toggle('my-app-dark')
    // if (tenantStore.themeSettings.darkMode !== bool) await tenantStore.updateThemeSettings({
    //   ...tenantStore.themeSettings,
    //   darkMode: bool,
    // })
  }
  async function saveThemeChangesInDB(theme: string) {
    try {
      const res = await updateTheme(theme)
    }
    catch (error) {
      console.error('Failed to save theme settings:', error)
    }

    // await updateSurfaceColor(tenantStore.themeSettings.surfaceColor, tenantStore.themeSettings.isSurfaceColorHex)
  }

  async function getThemeFromDBAndApply() {
    try {
      //   check if i am logged in

      const themeSetting = await getTheme()

      const { theme } = themeSetting.data || {}

      if (theme) {
        await changePrimaryColor(theme)
      }
    }
    catch (error) {
      console.error('Failed to apply theme settings:', error)
    }
  }
  async function ApplyThemeToPublicAppraisal(theme: string) {
    if (theme) {
      await changePrimaryColor(theme)
    }
  }
  return { changePreset, changePrimaryColor, changeSurfaceColor, changeDarkMode, saveThemeChangesInDB, getThemeFromDBAndApply, ApplyThemeToPublicAppraisal }
}
